import { useQuery } from '@tanstack/react-query'
import { desilApi } from '../lib/client'
import { ApiResponse, DesilFilteredResult, DesilFilter } from '../../../shared-lib/types'

export function useDesilFiltered(filters?: DesilFilter) {
    return useQuery<ApiResponse<DesilFilteredResult>>({
        queryKey: ['desil', 'filtered', filters],
        queryFn: async () => {
            try {
                return await desilApi.getFiltered(filters)
            } catch (error) {
                // Create structured error response
                const errorResponse: ApiResponse<DesilFilteredResult> = {
                    status: "error",
                    message: error instanceof Error ? error.message : "Gagal mengambil data desil dengan filter",
                    data: {
                        data: [],
                        totals: {
                            jumlahKpm: 0,
                            desil1: 0,
                            desil2: 0,
                            desil3: 0,
                            desil4: 0,
                            desil5: 0,
                            desil6_10: 0,
                            belumDiperingkat: 0,
                            total: 0
                        }
                    }
                }
                
                console.error('Error fetching filtered desil data:', error)
                throw errorResponse
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
        // Always enabled - backend will apply default 5-year range if no filters provided
        enabled: true
    })

}